import { render, staticRenderFns } from "./pharmacyLevelDetail-08.vue?vue&type=template&id=d008b81a&scoped=true"
import script from "./pharmacyLevelDetail-08.vue?vue&type=script&lang=js"
export * from "./pharmacyLevelDetail-08.vue?vue&type=script&lang=js"
import style0 from "./pharmacyLevelDetail-08.vue?vue&type=style&index=0&id=d008b81a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d008b81a",
  null
  
)

export default component.exports